module.exports = __webpack_public_path__ + "media/images/caixa_card-e0437adb.png";